var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1926,
    height: 40,
    viewBox: "0 0 1926 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3580_63424)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3580_63424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1926,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3580_63424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.71 67.1372C1844.95 123.118 1892.5 190.132 1926 264.807V-130.532C1892.52 -55.8372 1844.95 11.1559 1786.71 67.1372Z",
    fill: "url(#paint0_linear_3580_63424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.335 67.137C838.253 -1.17986 783.121 -85.9241 750.018 -180.998H362.291C416.72 -87.5487 447.937 21.1044 447.937 137.059C447.937 422.22 259.31 663.295 0.00195312 742.483V903.146H841.423C761.996 797.381 714.929 665.943 714.929 523.492C714.929 344.195 789.521 182.329 909.335 67.1571V67.137Z",
    fill: "url(#paint1_linear_3580_63424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.335 67.137C1023.13 -42.2382 1177.71 -109.472 1348.02 -109.472C1518.33 -109.472 1672.91 -42.2181 1786.71 67.137C1844.95 11.1557 1892.5 -55.8574 1926 -130.533V-180.998H750.019C783.122 -85.9241 838.273 -1.15979 909.335 67.137Z",
    fill: "url(#paint2_linear_3580_63424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.937 137.059C447.937 21.1044 416.72 -87.5287 362.291 -180.998H0.00195312V742.463C259.31 663.295 447.937 422.2 447.937 137.038V137.059Z",
    fill: "url(#paint3_linear_3580_63424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.336 67.1335C1023.13 176.509 1177.71 243.742 1348.02 243.742C1518.33 243.742 1672.92 176.489 1786.71 67.1335C1672.92 -42.2416 1518.33 -109.475 1348.02 -109.475C1177.71 -109.475 1023.13 -42.2216 909.336 67.1335Z",
    fill: "url(#paint4_linear_3580_63424)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3580_63424",
    x1: 1926,
    y1: 606.82,
    x2: 1926,
    y2: -426.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FF82B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EE2541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3580_63424",
    x1: 1226.28,
    y1: 1151.39,
    x2: -771.803,
    y2: 62.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FF82B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EE2541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3580_63424",
    x1: 689.718,
    y1: 67.2583,
    x2: 2691.8,
    y2: 67.2583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FF82B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EE2541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3580_63424",
    x1: -483.503,
    y1: 148.343,
    x2: 607.632,
    y2: 148.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FF82B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EE2541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3580_63424",
    x1: 1092.14,
    y1: 312.513,
    x2: 1446.51,
    y2: -468.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FF82B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EE2541"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3580_63424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLava);
export default __webpack_public_path__ + "static/media/lava.f53adddd64485668b364d9e23cd1cad6.svg";
export { ForwardRef as ReactComponent };